import { createStyles, makeStyles } from '@material-ui/core';

const styles = () => createStyles({
  modalWrapper: {
    borderRadius: '8px',
    padding: '10px',
    maxWidth: '500px',
    width: '100%',
  },
  titleBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    justifyContent: 'center',
    marginTop: '10px',
  },
  titleIcon: {
    color: '#d32f2f',
    fontSize: '2.1875rem',
  },
  titleText: {
    fontWeight: 'bold',
  },
  contentBox: {
    marginTop: '20px',
  },
  contentText: {
    color: 'rgba(0, 0, 0, 0.87)',
    marginBottom: '12px',
  },
  contactText: {
    marginTop: '16px',
    padding: '16px',
    backgroundColor: '#fdeded',
    borderRadius: '4px',
    borderLeft: '4px solid #ef5350',
    color: '#5f2120',
    wordBreak: 'break-word',
    overflowWrap: 'anywhere',
    lineHeight: '1.5',
  },
  contactLink: {
    margin: '0 4px',
    fontWeight: 500,
    textDecoration: 'none',
    color: '#007bff',
  },
  actionsBox: {
    padding: '0 24px 16px 24px',
    marginTop: '10px',
  },
  closeButton: {
    backgroundColor: '#1976d2',
    color: '#fff',
    width: '100%',
    textTransform: 'none',
    borderRadius: '6px',
    boxShadow: 'none',
    fontSize: '14px',
    fontWeight: 'bold',
    '&:hover': {
      backgroundColor: '#0d47a1',
      boxShadow: '0px 2px 4px rgba(0,0,0,0.2)',
    },
  },
});

const useStyles = makeStyles(styles);

export default useStyles;
